import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnitViewComponent } from './unit-view/unit-view.component';
import { UnitFormComponent } from './unit-form/unit-form.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { AngularMaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { UnitRoutingModule } from './unit-routing-module';



@NgModule({
  declarations: [
    UnitViewComponent,
    UnitFormComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    MatDialogModule,
    UnitRoutingModule,
    FormsModule, ReactiveFormsModule
  ]
})
export class UnitModule { }
